import type { DeploymentSummary } from "@situate/contracts/platform";
import {
  canViewDashboard,
  canViewLiveView,
  canViewAnalytics,
  canViewNotifications,
  canViewPlayback,
  // TODO: Re-enable when routes are available
  // canViewSettings,
} from "@/features/deployment-selection/model/permissions";
import { createDeploymentRoutePath } from "@/features/deployment-selection/utils/deployment-paths";

/**
 * Get the first accessible page route for a deployment.
 *
 * Checks pages in priority order:
 * 1. Dashboard
 * 2. Live view
 * 3. Analytics
 * 4. Notifications
 * 5. Historical Playback
 * 6. Deployment selection (fallback when no permissions)
 *
 * TODO: Re-enable when routes are available:
 * - Settings
 * - Help
 *
 * @param deployment - Deployment to check permissions for
 * @returns Path to the first accessible page, or "/deployments" if none are accessible
 */
export function getFirstAccessibleRoute(deployment: DeploymentSummary): string {
  const deploymentId = deployment.deployment_id;

  if (canViewDashboard(deployment)) {
    return createDeploymentRoutePath(deploymentId, "dashboard");
  }

  if (canViewLiveView(deployment)) {
    return createDeploymentRoutePath(deploymentId, "live");
  }

  if (canViewAnalytics(deployment)) {
    return createDeploymentRoutePath(deploymentId, "analytics");
  }

  if (canViewNotifications(deployment)) {
    return createDeploymentRoutePath(deploymentId, "notifications");
  }

  if (canViewPlayback(deployment)) {
    return createDeploymentRoutePath(deploymentId, "playback");
  }

  // if (canViewSettings(deployment)) {
  //   return createDeploymentRoutePath(deploymentId, "settings");
  // }

  // Redirect to deployment selection if user has no feature permissions
  return "/deployments";
}
